export const defaultEnTranslations = {
  title: 'AI Advisor',
  inputPlaceholder: 'Type your question',
  sendMessageButton: 'Send Message',
  poweredBy: 'Powered by',
  multiChoiceFindButton: 'Find it',
  failedMessage: 'Message not sent. Tap to retry',
  addToCartButton: 'Add to cart',
  checkItOut: 'Check it out',
  quantity: 'Quantity:',
  widget: {
    title: '<strong>AI</strong> Advisor',
    initPopup: {
      HOME: '',
      DEFAULT: 'Hi, any questions?',
      COLLECTION: '',
      PRODUCT: '',
    },
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: 'Can I help you with anything?',
    viewedProductsPopup: 'Browsing? Need help?',
    crossSalePopup: 'Want a complimentary item?',
    returnBackPopup: 'Return popup',
  },
  errors: {
    default: "Apologies, I'm currently unavailable. Please try again later.",
    emptyChatId: 'Chat ID is empty',
    notInitialized: 'Chat is not initialized. Please try again.',
    connectionFailure: 'Connection failure. Please try again.',
    noConnection: 'Unable to connect. Please check your internet connection and try again.',
    messageTooLong: 'Message is too long. Please shorten it.',
    messageNotDelivered: 'Message not delivered. Please try again.',
    addToCartFailure: 'Error adding the item to the cart. Please try again later.',
    variantNotAvailableForSale: 'This variant is not available for sale',
  },
  variants: {
    label: 'Choose {optionName}',
    emptySelectError: 'Oops, you didn’t select {optionsNames}',
    pleaseSelect: 'Please select',
  },
  prompts: {
    daily_routine: {
      caption: 'Daily routine',
    },
    ingredients: {
      caption: 'Ingredients',
    },
    how_to_use: {
      caption: 'How to use',
    },
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

type PopupText =
  | string
  | {
      HOME: string;
      DEFAULT: string;
      COLLECTION: string;
      PRODUCT: string;
    };

export type TranslationsType = Omit<typeof defaultEnTranslations, 'prompts'> & {
  widget: Omit<typeof defaultEnTranslations.widget, 'initPopup' | 'hoverPopup'> & {
    initPopup: PopupText;
    hoverPopup: PopupText;
  };
  prompts: Record<string, { prompt?: string; caption: string }>;
};

// French
export const defaultFrTranslations = {
  title: 'Conseiller IA',
  inputPlaceholder: 'Tapez votre question',
  sendMessageButton: 'Envoyer le message',
  poweredBy: 'Propulsé par',
  multiChoiceFindButton: 'Trouver',
  failedMessage: 'Message non envoyé. Touchez pour réessayer',
  addToCartButton: 'Ajouter au panier',
  checkItOut: 'Regarde ça',
  quantity: 'Quantité :',
  widget: {
    title: '<strong>AI</strong> Advisor',
    initPopup: {
      HOME: '',
      DEFAULT: 'Salut, des questions ?',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: 'Puis-je vous aider avec quelque chose ?',
    viewedProductsPopup: 'Vous naviguez ? Besoin d’aide ?',
    crossSalePopup: 'Voulez-vous un article complémentaire ?',
    returnBackPopup: 'Retour',
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
  },
  errors: {
    default: 'Désolé, je ne suis pas disponible pour le moment. Veuillez réessayer plus tard.',
    emptyChatId: 'L’ID de chat est vide',
    notInitialized: 'Le chat n’est pas initialisé. Veuillez réessayer.',
    connectionFailure: 'Échec de la connexion. Veuillez réessayer.',
    noConnection: 'Impossible de se connecter. Veuillez vérifier votre connexion internet et réessayer.',
    messageTooLong: 'Le message est trop long. Veuillez le raccourcir.',
    messageNotDelivered: 'Message non délivré. Veuillez réessayer.',
    addToCartFailure: 'Erreur lors de l’ajout de l’article au panier. Veuillez réessayer plus tard.',
    variantNotAvailableForSale: 'Ce variant n’est pas disponible à la vente.',
  },
  variants: {
    label: 'Choisissez {optionName}',
    emptySelectError: 'Oups, vous n’avez pas sélectionné {optionsNames}',
    pleaseSelect: 'Veuillez sélectionner',
  },
  prompts: {
    daily_routine: {
      caption: 'Routine quotidienne',
    },
    ingredients: {
      caption: 'Ingrédients',
    },
    how_to_use: {
      caption: 'Comment utiliser',
    },
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

// German
export const defaultDeTranslations = {
  title: 'KI-Berater',
  inputPlaceholder: 'Geben Sie Ihre Frage ein',
  sendMessageButton: 'Nachricht senden',
  poweredBy: 'Angetrieben von',
  multiChoiceFindButton: 'Finden',
  failedMessage: 'Nachricht nicht gesendet. Tippen zum Wiederholen',
  addToCartButton: 'In den Warenkorb',
  checkItOut: 'Schau es dir an',
  quantity: 'Menge:',
  widget: {
    title: '<strong>AI</strong> Advisor',
    stuckPopup: 'Kann ich Ihnen bei etwas helfen?',
    viewedProductsPopup: 'Stöbern? Brauchen Sie Hilfe?',
    crossSalePopup: 'Möchten Sie einen kostenlosen Artikel?',
    returnBackPopup: 'Zurück',
    initPopup: {
      HOME: '',
      DEFAULT: 'Hallo, Fragen?',
      COLLECTION: '',
      PRODUCT: '',
    },
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
  },
  errors: {
    default: 'Entschuldigung, ich bin derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.',
    emptyChatId: 'Chat-ID ist leer',
    notInitialized: 'Chat ist nicht initialisiert. Bitte versuchen Sie es erneut.',
    connectionFailure: 'Verbindungsfehler. Bitte versuchen Sie es erneut.',
    noConnection: 'Keine Verbindung möglich. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.',
    messageTooLong: 'Nachricht ist zu lang. Bitte kürzen Sie sie.',
    messageNotDelivered: 'Nachricht nicht zugestellt. Bitte versuchen Sie es erneut.',
    addToCartFailure: 'Fehler beim Hinzufügen des Artikels zum Warenkorb. Bitte versuchen Sie es später erneut.',
    variantNotAvailableForSale: 'Diese Variante ist nicht zum Verkauf verfügbar.',
  },
  variants: {
    label: 'Wähle {optionName}',
    emptySelectError: 'Ups, Sie haben {optionsNames} nicht ausgewählt',
    pleaseSelect: 'Bitte auswählen',
  },
  prompts: {
    daily_routine: {
      caption: 'Tägliche Routine',
    },
    ingredients: {
      caption: 'Zutaten',
    },
    how_to_use: {
      caption: 'Wie zu verwenden',
    },
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

// Spanish
export const defaultEsTranslations = {
  title: 'Asesor de IA',
  inputPlaceholder: 'Escribe tu pregunta',
  sendMessageButton: 'Enviar mensaje',
  poweredBy: 'Desarrollado por',
  multiChoiceFindButton: 'Encontrar',
  failedMessage: 'Mensaje no enviado. Toca para reintentar',
  addToCartButton: 'Agregar al carrito',
  checkItOut: 'Échale un vistazo',
  quantity: 'Cantidad:',
  widget: {
    title: '<strong>AI</strong> Advisor',
    initPopup: {
      HOME: '',
      DEFAULT: 'Hola, ¿alguna pregunta?',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: '¿Puedo ayudarte con algo?',
    viewedProductsPopup: '¿Navegando? ¿Necesitas ayuda?',
    crossSalePopup: '¿Quieres un artículo complementario?',
    returnBackPopup: 'Volver',
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
  },
  errors: {
    default: 'Lo siento, actualmente no estoy disponible. Por favor, inténtalo más tarde.',
    emptyChatId: 'El ID del chat está vacío',
    notInitialized: 'El chat no está inicializado. Por favor, inténtalo de nuevo.',
    connectionFailure: 'Fallo en la conexión. Por favor, inténtalo de nuevo.',
    noConnection: 'No se puede conectar. Verifica tu conexión a internet e inténtalo de nuevo.',
    messageTooLong: 'El mensaje es demasiado largo. Por favor, acórtalo.',
    messageNotDelivered: 'Mensaje no entregado. Por favor, inténtalo de nuevo.',
    addToCartFailure: 'Error al añadir el artículo al carrito. Por favor, inténtalo más tarde.',
    variantNotAvailableForSale: 'Esta variante no está disponible para la venta.',
  },
  variants: {
    label: 'Elige {optionName}',
    emptySelectError: 'Ups, no seleccionaste {optionsNames}',
    pleaseSelect: 'Por favor seleccione',
  },
  prompts: {
    daily_routine: {
      caption: 'Rutina diaria',
    },
    ingredients: {
      caption: 'Ingredientes',
    },
    how_to_use: {
      caption: 'Cómo usar',
    },
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

// Hebrew
export const defaultHeTranslations = {
  title: 'יועץ AI',
  inputPlaceholder: 'הקלידו כאן',
  sendMessageButton: 'שלח ',
  poweredBy: 'מופעל על-ידי',
  multiChoiceFindButton: 'מצא זאת',
  failedMessage: 'ההודעה לא נשלחה. הקישו כדי לנסות שוב',
  addToCartButton: 'הוסף לעגלה',
  checkItOut: 'למידע נוסף',
  quantity: 'כמות:',
  widget: {
    title: '<strong>יועץ</strong> בינה מלאכותית',
    initPopup: {
      HOME: '',
      DEFAULT: 'היי, יש לך שאלות?',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: 'אפשר לעזור במשהו?',
    viewedProductsPopup: 'גולשים? צריכים עזרה?',
    crossSalePopup: 'רוצים פריט נוסף במתנה?',
    returnBackPopup: 'חזרה',
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
  },
  errors: {
    default: 'מצטער, אני לא זמין כרגע. אנא נסו שוב מאוחר יותר.',
    emptyChatId: 'מזהה הצ׳אט ריק',
    notInitialized: 'הצ׳אט לא מאותחל. אנא נסו שוב.',
    connectionFailure: 'כשל בחיבור. אנא נסו שוב.',
    noConnection: 'לא ניתן להתחבר. אנא בדקו את חיבור האינטרנט ונסו שוב.',
    messageTooLong: 'ההודעה ארוכה מדי. אנא קצרו אותה.',
    messageNotDelivered: 'ההודעה לא נמסרה. אנא נסו שוב.',
    addToCartFailure: 'שגיאה בהוספת הפריט לעגלה. אנא נסו שוב מאוחר יותר.',
    variantNotAvailableForSale: 'הגרסה הזו אינה זמינה למכירה.',
  },
  variants: {
    label: 'בחרו {optionName}',
    emptySelectError: 'אופס, לא בחרתם אופציה {optionsNames}',
    pleaseSelect: 'אנא בחרו',
  },
  prompts: {
    daily_routine: {
      caption: 'שגרה יומית',
    },
    ingredients: {
      caption: 'מרכיבים',
    },
    how_to_use: {
      caption: 'איך להשתמש',
    },
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

// Greek
export const defaultElTranslations = {
  title: 'Σύμβουλος AI',
  inputPlaceholder: 'Πληκτρολογήστε την ερώτησή σας',
  sendMessageButton: 'Αποστολή μηνύματος',
  poweredBy: 'Λειτουργεί με',
  multiChoiceFindButton: 'Βρείτε το',
  failedMessage: 'Το μήνυμα δεν στάλθηκε. Πατήστε για επανάληψη',
  addToCartButton: 'Προσθήκη στο καλάθι',
  checkItOut: 'Δες το (Des to)',
  quantity: 'Ποσότητα:',
  widget: {
    title: '<strong>AI</strong> Advisor',
    initPopup: {
      HOME: '',
      DEFAULT: 'Γεια, έχετε καμιά ερώτηση;',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: 'Μπορώ να σας βοηθήσω σε κάτι;',
    viewedProductsPopup: 'Περιηγείστε; Χρειάζεστε βοήθεια;',
    crossSalePopup: 'Θέλετε ένα συμπληρωματικό προϊόν;',
    returnBackPopup: 'Επιστροφή',
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
  },
  errors: {
    default: 'Ζητούμε συγγνώμη, προς το παρόν δεν είμαι διαθέσιμος. Παρακαλώ δοκιμάστε αργότερα.',
    emptyChatId: 'Το ID συζήτησης είναι κενό',
    notInitialized: 'Η συζήτηση δεν έχει ξεκινήσει. Παρακαλώ δοκιμάστε ξανά.',
    connectionFailure: 'Αποτυχία σύνδεσης. Παρακαλώ δοκιμάστε ξανά.',
    noConnection: 'Δεν είναι δυνατή η σύνδεση. Ελέγξτε τη σύνδεση στο διαδίκτυο και δοκιμάστε ξανά.',
    messageTooLong: 'Το μήνυμα είναι πολύ μεγάλο. Παρακαλώ συντομεύστε το.',
    messageNotDelivered: 'Το μήνυμα δεν παραδόθηκε. Παρακαλώ δοκιμάστε ξανά.',
    addToCartFailure: 'Σφάλμα κατά την προσθήκη του αντικειμένου στο καλάθι. Παρακαλώ δοκιμάστε αργότερα.',
    variantNotAvailableForSale: 'Esta variante no está disponible para la venta.',
  },
  variants: {
    label: 'Επιλέξτε {optionName}',
    emptySelectError: 'Ουπς, δεν επιλέξατε {optionsNames}',
    pleaseSelect: 'Παρακαλώ επιλέξτε',
  },
  prompts: {
    daily_routine: {
      caption: 'Καθημερινή ρουτίνα',
    },
    ingredients: {
      caption: 'Συστατικά',
    },
    how_to_use: {
      caption: 'Πώς να χρησιμοποιήσετε',
    },
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

// Portuguese (Brazil)
export const defaultPtBRTranslations = {
  title: 'Consultor de IA',
  inputPlaceholder: 'Digite sua pergunta',
  sendMessageButton: 'Enviar mensagem',
  poweredBy: 'Desenvolvido por',
  multiChoiceFindButton: 'Encontrar',
  failedMessage: 'Mensagem não enviada. Toque para tentar novamente',
  addToCartButton: 'Adicionar ao carrinho',
  checkItOut: 'Confere isso',
  quantity: 'Quantidade:',
  widget: {
    title: '<strong>AI</strong> Advisor',
    initPopup: {
      HOME: '',
      DEFAULT: 'Oi, alguma dúvida?',
      COLLECTION: '',
      PRODUCT: '',
    },
    stuckPopup: 'Posso te ajudar com algo?',
    viewedProductsPopup: 'Navegando? Precisa de ajuda?',
    crossSalePopup: 'Quer um item complementar?',
    returnBackPopup: 'Voltar',
    hoverPopup: {
      HOME: '',
      DEFAULT: '',
      COLLECTION: '',
      PRODUCT: '',
    },
  },
  errors: {
    default: 'Desculpe, atualmente não estou disponível. Por favor, tente novamente mais tarde.',
    emptyChatId: 'ID do chat está vazio',
    notInitialized: 'Chat não inicializado. Por favor, tente novamente.',
    connectionFailure: 'Falha de conexão. Por favor, tente novamente.',
    noConnection: 'Não foi possível conectar. Verifique sua conexão com a internet e tente novamente.',
    messageTooLong: 'A mensagem é muito longa. Por favor, encurte-a.',
    messageNotDelivered: 'Mensagem não entregue. Por favor, tente novamente.',
    addToCartFailure: 'Erro ao adicionar o item ao carrinho. Por favor, tente novamente mais tarde.',
    variantNotAvailableForSale: 'Esta variante não está disponível para venda',
  },
  variants: {
    label: 'Escolha {optionName}',
    emptySelectError: 'Ops, você não selecionou {optionsNames}',
    pleaseSelect: 'Por favor selecione',
  },
  prompts: {
    daily_routine: {
      caption: 'Rotina diária',
    },
    ingredients: {
      caption: 'Ingredientes',
    },
    how_to_use: {
      caption: 'Como usar',
    },
  },

  // Deprecated

  widgetTitle: '',
  widgetTooltip: '',
};

export const defaultTranslations = {
  en: defaultEnTranslations,
  fr: defaultFrTranslations,
  de: defaultDeTranslations,
  es: defaultEsTranslations,
  he: defaultHeTranslations,
  el: defaultElTranslations,
  'pt-BR': defaultPtBRTranslations,
} satisfies Record<string, TranslationsType>;
